import React, { useState } from 'react';
import './HomePage.css';
import AboutModal from './AboutModal';  // ← ДОДАНО


function HomePage({ setCurrentPage }) {
  const [showDoctrine, setShowDoctrine] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);  // ← ДОДАНО


  return (
    <div className="home-container">
      <div className="logo-section">
        <img 
          src="/logo.png" 
          alt="Genesis by THEO" 
          className="main-logo"
        />
      </div>


      <div className="action-buttons">
        <button 
          className="btn-primary"
          onClick={() => setCurrentPage('register')}
        >
          Register
        </button>
        <button 
          className="btn-secondary"
          onClick={() => setCurrentPage('login')}
        >
          Sign In
        </button>
        <button 
          className="btn-casting"
          onClick={() => setCurrentPage('casting-menu')}
        >
          Casting call
        </button>
        <button 
          className="btn-secondary"
          onClick={() => setShowAboutModal(true)}  // ← ЗМІНЕНО
        >
          About
        </button>
      </div>


      <div className="doctrine-container">
        <button 
          className="doctrine-trigger" 
          onClick={() => setShowDoctrine(!showDoctrine)}
        >
          {showDoctrine ? "↑ Collapse Doctrine" : "Click here to learn about Doctrine Genesis by THEO"}
        </button>
        
        {showDoctrine && (
          <div className="brand-description">
            <h3 className="doctrine-title">The Progression of Human Creation</h3>
            <p>Human creation begins as energy, becomes one through unity, and awakens at the first breath.</p>
            
            <p className="bold">Creation Is a Progression</p>
            <p>Creation is not myth.</p>
            <p>Creation is not metaphor.</p>
            <p>Creation is a progression governed by energy, biology, and purpose.</p>
            <p>Energy cannot be created or destroyed.</p>
            <p>Energy is transferred.</p>


            <p className="bold">Creation Begins as Energy</p>
            <p>Human creation does not begin at birth.</p>
            <p>Human creation does not begin at conception.</p>
            <p>Human creation begins as energy.</p>
            <p>The sperm carries energy.</p>
            <p>The egg carries energy.</p>
            <p>Each exists independently as a living source of life.</p>
            <p>Each is active, not lifeless.</p>
            <p>Each single cell carries memory, wisdom, instinct, and encoded potential.</p>
            <p>Each carries lineage and accumulated human experience.</p>


            <p className="bold">DNA: Memory, Wisdom, and Instinct</p>
            <p>DNA does not merely store biological instructions.</p>
            <p>DNA carries memory.</p>
            <p>DNA transfers accumulated human wisdom and instinct.</p>
            <p>This explains what appears before learning:</p>
            <p>Instinct before instruction.</p>
            <p>Intuition before language.</p>
            <p>Recognition without experience.</p>
            <p>Fear, empathy, courage, and survival without teaching.</p>
            <p>Memory precedes experience.</p>
            <p>This is why humans know things they have never learned.</p>


            <p className="bold">Dreams, Déjà Vu, and Unlocked Memory</p>
            <p>Humans experience moments that do not align with linear memory.</p>
            <p>Déjà vu.</p>
            <p>Vivid dreams of places never visited.</p>
            <p>Instinctive recognition without prior exposure.</p>
            <p>These experiences are often dismissed as illusion.</p>
            <p>Genesis does not dismiss them.</p>
            <p>They may represent unlocked inherited, instinctive, or energetic memory - consciousness accessing memory not acquired through personal experience.</p>


            <p className="bold">Unity — The Miracle</p>
            <p>The miracle is unity.</p>
            <p>Unity occurs when two single cells - the sperm and the egg - each carrying its own source of energy, come together.</p>
            <p>Masculine and feminine energies unite.</p>
            <p>Two energies become one unique individual.</p>
            <p>Not copied.</p>
            <p>Not repeated.</p>
            <p>Not equal.</p>


            <p className="bold">Equality, Uniqueness, and Purpose</p>
            <p>Humans are equal in dignity.</p>
            <p>Humans are not equal in configuration, capacity, or purpose.</p>
            <p>This truth is controversial.</p>
            <p>It is also unavoidable.</p>
            <p>Each human enters existence with a unique purpose.</p>
            <p>Purpose is not fixed.</p>
            <p>Purpose can evolve as the human evolves.</p>


            <p className="bold">Preparation in the Womb</p>
            <p>Creation continues through gestation.</p>
            <p>In the womb, there is heartbeat.</p>
            <p>There is brain activity.</p>
            <p>Both are measured as waves.</p>
            <p>Life in the womb operates through frequency, rhythm, and response - just as universal energy exists as frequency.</p>
            <p>There is growth.</p>
            <p>There is response.</p>
            <p>There is awareness.</p>
            <p>There is no breath.</p>
            <p>Without breath, creation is prepared, not awakened.</p>


            <p className="bold">Awakening at the First Breath</p>
            <p>Creation awakens at the first breath.</p>
            <p>The first breath is one unified event.</p>
            <p>Chemistry, biology, and energy ignite together - not separately.</p>
            <p>Oxygen enters the body.</p>
            <p>Universal energy activates the being.</p>
            <p>This ignition may be the tuning moment - the moment the individual aligns with the universal frequency and becomes fully present.</p>
            <p>Before breath, there is formation.</p>
            <p>At breath, there is activation and autonomy.</p>
            <p>This is not the beginning of creation.</p>
            <p>It is the awakening of a created being into existence.</p>


            <p className="bold">A Necessary Correction</p>
            <p>Michelangelo captured beauty.</p>
            <p>He misrepresented the moment of creation.</p>
            <p>Creation is not divine touch.</p>
            <p>Creation is not contact between fingers.</p>
            <p>Creation is energy awakening through breath.</p>
            <p>This distinction matters.</p>


            <p className="bold">The Meaning of the GENESIS by THEO Logo</p>
            <p>The GENESIS by THEO logo is not decorative.</p>
            <p>It is instructional.</p>
            <p>The logo shows man and woman - two sources of energy - moving toward unity.</p>
            <p>The space between them represents the moment before awakening - the transition from preparation to presence.</p>
            <p>The light represents the True Light (Φως το Аληθινό) - the Light of Heart and Soul - expressed through human purpose.</p>
            <p>The geometry reflects continuity, balance, and progression.</p>
            <p>Nothing is random.</p>
            <p>Nothing is ornamental.</p>


            <p className="bold">The Olympic Flame and the True Light</p>
            <p>The Olympic Flame represents continuity of life, purpose, and civilization.</p>
            <p>GENESIS aligns with the Flame - not as competition for crowns or applause, but as a reminder of inner excellence.</p>
            <p>The True Light is not performance.</p>
            <p>It is purpose.</p>


            <p className="bold">Canonical Statement</p>
            <p>Human creation begins as two single sources of energy, becomes one through unity, and awakens at the first breath - where chemistry, biology, and energy ignite as one, creating the unique individual expressed through the Five Divine Human Characteristics.</p>


            <p className="bold">The Five Divine Human Characteristics</p>
            <p>Soma (Σώμα)</p>
            <p>Sofia (Σофія)</p>
            <p>Psihi (Ψυχή)</p>
            <p>Tharos (Θάρρος)</p>
            <p>Skopos (Σкопός)</p>
            <p>These are foundational dimensions of the human being.</p>


            <p className="bold">Genesis Comes First</p>
            <p>GENESIS by THEO is foundational.</p>
            <p>It precedes education, recognition systems, economies, governance, and artificial intelligence.</p>
            <p>Any system built without defining the human becomes corrupt.</p>
            <p>Genesis defines the human baseline before any system is built.</p>


            <p className="bold">Supporting Systems</p>
            <p>Genesis is not powered by technology.</p>
            <p>Technology exists to serve Genesis.</p>
            <p>Digital systems may express identity, merit, and trust.</p>
            <p>Genesis remains the source.</p>
          </div>
        )}
      </div>

      {/* AboutModal компонент */}
      <AboutModal 
        isOpen={showAboutModal} 
        onClose={() => setShowAboutModal(false)} 
      />  
      {/* ← ДОДАНО */}

    </div>
  );
}


export default HomePage;
